'use client';
var classes = {"root":"m_b32e4812","svg":"m_d43b5134","curve":"m_b1ca1fbf","label":"m_b23f9dc4"};

export { classes as default };
//# sourceMappingURL=RingProgress.module.css.mjs.map
